import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { Customer, CustomerFilters } from "../../models/customer.model";

export const customersActions = createActionGroup({
    source: 'Customers',
    events: {
        'Load Customers': props<{data: CustomerFilters|null}>(),
        'Load Customers Success': props<{payload: Customer[]}>(),
        'Load Customer Fail': emptyProps(),

        'Assign Agent': props<{data: {customer_ids: number[], new_user_id: number}}>(),
    }
})